import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
// svg-icon
import '@/icons'
// 基础样式
import '@/style/reset.css'
import 'vant/lib/index.less'
import '@/style/commonStyle.less'
// 引入vant
import Vant from 'vant'
import { Lazyload } from 'vant'

import VueQr from 'vue-qr'
// 复制到剪切板工具
import VueClipboard from 'vue-clipboard2'

// 全局注册自定义组件
import { permission } from '@/utils/permission'

Vue.use(Lazyload)
Vue.use(Vant)
Vue.use(permission)
Vue.component('VueQr', VueQr)
Vue.use(VueClipboard)

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
